import api from './api';

export const getReports = (params) => api.get('/api/generated-reports', { params });
export const getReport = (id) => api.get(`/api/generated-reports/${id}`);
export const generateReport = (data) => api.post('/api/generated-reports/generate', data);
export const updateReport = (id, data) => api.put(`/api/generated-reports/${id}`, data);
export const publishReport = (id) => api.put(`/api/generated-reports/${id}/publish`);
export const archiveReport = (id) => api.delete(`/api/generated-reports/${id}`);
